import CircularLoader from "app/components/CircularLoader";
import { selectMentionData } from "app/components/ReplyComment/redux/selectors";
import { IMemberList } from "app/containers/Features/components/MemberSelection/types";
import React from "react";
import { useSelector } from "react-redux";
import MemberMentionItem from "../MemberMentionItem";

const RenderMemberItems = ({
  handleMemberSelect,
  filteredMembers,
  memberLoading,
  projectId,
}: {
  projectId: string;
  handleMemberSelect: (member: IMemberList) => void;
  filteredMembers: IMemberList[];
  memberLoading: boolean;
}) => {
  // Global State
  const mentionData = useSelector(selectMentionData);

  // Variables
  const ticketData = mentionData[projectId as string]?.tickets;

  return (
    <>
      {memberLoading ? (
        <div className="w-full flex items-center justify-center py-3 h-24">
          <CircularLoader size="md" />
        </div>
      ) : (
        <div className="flex flex-col overflow-y-auto max-h-[300px]">
          {filteredMembers?.length > 0 ? (
            filteredMembers?.map((member) => (
              <MemberMentionItem
                key={member?._id}
                member={member as IMemberList}
                onSelect={handleMemberSelect}
              />
            ))
          ) : (
            <div className="px-4 py-8 text-center text-gray-500">
              No members found
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default RenderMemberItems;
